export { InjectablePlaceholderComponent as InjectablePlaceholder } from "./Injectable";
